// custom to WISPR-lab/data-export-gui


import { getDB } from '../index.js';
import * as events from './events.js';


export async function getEventMeta(dbName) {
  /* Returns a metadata envelope with field mappings, tag aggregations, and total count; includes empty compatibility stubs for a previous Elasticsearch-based API contract. */
  const db = await getDB(dbName);
  if (!db) {
    throw new Error('Database not initialized');
  }
  
  const countResult = await db.exec('SELECT COUNT(*) as count FROM events', 
    {returnValue: 'resultRows', rowMode: 'object'}
  );

  let mappings = [];
  let totalItems = 0
  let filterLabels = [];
  
  if (countResult.length !== 0) {
    mappings = await db.exec(
        'SELECT field, type FROM v_event_field_mappings ORDER BY field ASC', 
        { returnValue: 'resultRows', rowMode: 'object'}
    );
    totalItems = (countResult[0] && countResult[0].count) || 0;
    
    try {
      filterLabels = await events.getEventTags(dbName);
    } catch (e) {
      console.warn('Failed to get event tags:', e);
      filterLabels = [];
    }
  }
  
  return {
    mappings: mappings || [],
    attributes: {},
    filter_labels: filterLabels || [],
    count_per_index: {},
    emojis: {},
    search_node: null,
    total_items: totalItems
  };
}



export async function getDeviceMeta(dbName) {
    const db = await getDB(dbName);
    const mappings = await db.exec(
        'SELECT field, type FROM v_device_field_mappings ORDER BY field ASC', 
        { returnValue: 'resultRows', rowMode: 'object'}
    );
  
  const countResult = await db.exec('SELECT COUNT(*) as count FROM devices_raw', 
    {returnValue: 'resultRows', rowMode: 'object'}
  );
  const totalItems = (countResult[0] && countResult[0].count) || 0;
  
  return {
    mappings: mappings || [],
    attributes: {},
    filter_labels: [],
    count_per_index: {},
    emojis: {},
    search_node: null,
    total_items: totalItems
  };
}